//! Types for dbt GraphQl API, fetched from: https://docs.getdbt.com/docs/dbt-cloud-apis/sl-graphql#querying
export var DbtTimeGranularity;
(function (DbtTimeGranularity) {
    DbtTimeGranularity["NANOSECOND"] = "NANOSECOND";
    DbtTimeGranularity["MICROSECOND"] = "MICROSECOND";
    DbtTimeGranularity["MILLISECOND"] = "MILLISECOND";
    DbtTimeGranularity["SECOND"] = "SECOND";
    DbtTimeGranularity["MINUTE"] = "MINUTE";
    DbtTimeGranularity["HOUR"] = "HOUR";
    DbtTimeGranularity["DAY"] = "DAY";
    DbtTimeGranularity["WEEK"] = "WEEK";
    DbtTimeGranularity["MONTH"] = "MONTH";
    DbtTimeGranularity["QUARTER"] = "QUARTER";
    DbtTimeGranularity["YEAR"] = "YEAR";
})(DbtTimeGranularity || (DbtTimeGranularity = {}));
export var DbtDimensionType;
(function (DbtDimensionType) {
    DbtDimensionType["CATEGORICAL"] = "CATEGORICAL";
    DbtDimensionType["TIME"] = "TIME";
})(DbtDimensionType || (DbtDimensionType = {}));
export var DbtMetricType;
(function (DbtMetricType) {
    DbtMetricType["SIMPLE"] = "SIMPLE";
    DbtMetricType["RATIO"] = "RATIO";
    DbtMetricType["CUMULATIVE"] = "CUMULATIVE";
    DbtMetricType["DERIVED"] = "DERIVED";
    DbtMetricType["CONVERSION"] = "CONVERSION";
})(DbtMetricType || (DbtMetricType = {}));
export var DbtQueryStatus;
(function (DbtQueryStatus) {
    DbtQueryStatus["PENDING"] = "PENDING";
    DbtQueryStatus["RUNNING"] = "RUNNING";
    DbtQueryStatus["COMPILED"] = "COMPILED";
    DbtQueryStatus["SUCCESSFUL"] = "SUCCESSFUL";
    DbtQueryStatus["FAILED"] = "FAILED";
})(DbtQueryStatus || (DbtQueryStatus = {}));
// TODO: add more operators, there is probably reusable code in our semantic layer
export var DbtWhereOperator;
(function (DbtWhereOperator) {
    DbtWhereOperator["IN"] = "IN";
    DbtWhereOperator["NOT_IN"] = "NOT IN";
    DbtWhereOperator["EQUALS"] = "=";
    DbtWhereOperator["NOT_EQUALS"] = "!=";
    DbtWhereOperator["GTE"] = ">=";
    DbtWhereOperator["GT"] = ">";
    DbtWhereOperator["LTE"] = "<=";
    DbtWhereOperator["LT"] = "<";
})(DbtWhereOperator || (DbtWhereOperator = {}));
//# sourceMappingURL=dbtSemanticLayer.js.map